import { render, staticRenderFns } from "./ReplacementBillList.vue?vue&type=template&id=461d978f&"
import script from "./ReplacementBillList.vue?vue&type=script&lang=js&"
export * from "./ReplacementBillList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports